export default "__VITE_ASSET__c59417c1__"